import React from 'react';
import { CheckIcon, StarIcon, ZapIcon, RotateCcwIcon } from 'lucide-react';
import { bonuses } from '../../data/content';
import { images } from '../../data/images';
import { useCountdown } from '../../hooks/useCountdown';
import { CtaButton } from './CtaButton';
export function OfferCard() {
  const {
    minutes,
    seconds
  } = useCountdown(14 * 60 + 59);
  return <section id="offer" className="scroll-mt-4 bg-cream py-20 sm:py-28" data-id="element-133" data-mp="qdfb1bak1uid">
      <div className="mx-auto max-w-6xl px-6 lg:px-10" data-id="element-134" data-mp="ldj4b4ah3oz4">
        <div className="grid overflow-hidden rounded-[4px] border border-ink/15 bg-white lg:grid-cols-2" data-id="element-135" data-mp="gkq2opaawwr9">
          <div className="relative flex items-center bg-sand" data-id="element-136" data-mp="civ25n072nej">
            <img src={images.product} alt="No-Work Renovations book, tablet and phone screens, workbook, and bonus guides including the Renovation Planner and Materials Catalogue" className="aspect-[4/3] w-full object-cover" data-id="element-137" data-mp="cha4hoil2ocg" />
            <span className="absolute left-5 top-5 bg-danger px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-white" data-id="element-138" data-mp="3tr9okhd26b30">Today only</span>
          </div>

          <div className="p-8 sm:p-12" data-id="element-139" data-mp="176dirgqhydr0">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-140" data-mp="1bzootfnhiqhv">Complete access</p>
            <div className="mt-3 flex items-center gap-2 text-sm text-body" data-id="element-141" data-mp="xb21aqnpesfk">
              <span className="flex text-gold" aria-label="Rated 4.8 out of 5" data-id="element-142" data-mp="1293wg9yemi7e">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden data-id="element-143" data-mp="1q09bwo0fn8h6" data-mpi={i} />)}
              </span>
              <span data-id="element-144" data-mp="1ux9gsvljq56p"><strong className="text-ink" data-id="element-145" data-mp="1uvye6z3u73h6">4.8 / 5.0</strong> (+1,253 downloads)</span>
            </div>
            <h2 className="mt-5 font-serif text-2xl font-bold leading-snug text-ink sm:text-3xl" data-id="element-146" data-mp="1g2uual2rwdna">
              Makeover Easy: 101 Smart Ways to Transform Your Home + 8 Free Bonuses
            </h2>

            <div className="mt-6 flex items-end gap-4" data-id="element-147" data-mp="4nprzi6k0h47">
              <span className="text-xl text-body line-through decoration-danger/70" data-id="element-148" data-mp="9lr75s0uzwae">$49.99</span>
              <span className="font-serif text-6xl font-bold leading-none text-ink" data-id="element-149" data-mp="2c6bpaqd0cqj4">$27 <span className="font-sans text-lg font-bold text-body" data-id="element-150" data-mp="278insamngkp6">USD</span></span>
            </div>
            <p className="mt-3 inline-block bg-gold-soft px-3 py-1 text-xs font-bold uppercase tracking-wider text-ink" data-id="element-151" data-mp="22h0jpdpby3zz">
              Save $22.99 — 46% off
            </p>

            <ul className="mt-7 space-y-3" data-id="element-152" data-mp="1xgmk8k1so2dk">
              <li className="flex gap-3 text-[15px] leading-relaxed text-ink" data-id="element-153" data-mp="1skfdip1kqmuk">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden data-id="element-154" data-mp="1oh99zp5uj9rs" />
                <span className="flex-1 font-bold" data-id="element-155" data-mp="1jifvpuiqjeqk">101 practical solutions organized by room and problem</span>
              </li>
              {bonuses.map((b, i) => <li key={b.title} className="flex gap-3 text-[15px] leading-relaxed text-ink" data-id="element-156" data-mp="1elpirg288z9d" data-mpi={i}>
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden data-id="element-157" data-mp="3dumk5v0n3s0t" />
                  <span className="flex-1" data-id="element-158" data-mp="38yfbvvkru4fp">
                    <strong className="font-bold" data-id="element-159" data-mp="3gherrr90xdub">Bonus #{i + 1}:</strong> {b.title}
                  </span>
                  <span className="shrink-0 whitespace-nowrap text-sm" data-id="element-160" data-mp="3lfq20338dqd2">
                    <span className="text-body line-through" data-id="element-161" data-mp="3ldvkyzv2yie9">{b.price}</span>{' '}
                    <span className="font-bold text-gold" data-id="element-162" data-mp="3q91d4gf2stas">Free</span>
                  </span>
                </li>)}
            </ul>

            <CtaButton variant="gold" checkout className="mt-8 w-full" data-id="element-163" data-mp="2xisvqqsd6cx9">I want my 101 solutions</CtaButton>
            <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-body" data-id="element-164" data-mp="32gklbe5jdmya">
              <li className="flex items-center gap-1.5" data-id="element-165" data-mp="37fff1b51kvx6"><CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden data-id="element-166" data-mp="37itfgdu5av1z" />One-time payment</li>
              <li className="flex items-center gap-1.5" data-id="element-167" data-mp="3cdgvdob32h4y"><ZapIcon className="h-3.5 w-3.5 text-gold" aria-hidden data-id="element-168" data-mp="mqrb92lctwm7" />Instant access</li>
              <li className="flex items-center gap-1.5" data-id="element-169" data-mp="rp2n1iv7mh72"><RotateCcwIcon className="h-3.5 w-3.5 text-gold" aria-hidden data-id="element-170" data-mp="rnrgjbadqvc9" />7-Day Guarantee</li>
            </ul>

            <div className="mt-8 border-t border-ink/10 pt-6 text-center" data-id="element-171" data-mp="paxok0vuyzff">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-ink" data-id="element-172" data-mp="ladsl0n0u1uv">Your reserved price is available for:</p>
              <div className="mt-3 flex items-center justify-center gap-3 font-serif text-ink" role="timer" aria-live="off" data-id="element-173" data-mp="za4z6gb7kfyu">
                <TimeUnit value={minutes} label="min" data-id="element-174" data-mp="189ibrhumpkns" />
                <span className="text-3xl font-bold text-gold" data-id="element-175" data-mp="187yvvscvxbmj">:</span>
                <TimeUnit value={seconds} label="sec" data-id="element-176" data-mp="148q24nhuhdqz" />
              </div>
              <p className="mt-3 text-sm text-body" data-id="element-177" data-mp="1hz1xcv9q7smc">After that, the regular price goes back to $49.99.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function TimeUnit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex min-w-[76px] flex-col items-center bg-ink px-4 py-2 text-cream" data-id="element-178" data-mp="1rxr3xrw69qna">
      <span className="text-3xl font-bold tabular-nums" data-id="element-179" data-mp="1mzzauujsjyhi">{value}</span>
      <span className="font-sans text-[10px] font-bold uppercase tracking-widest text-gold-soft" data-id="element-180" data-mp="26jy60ts0zjk6">{label}</span>
    </div>;
}